import { render, staticRenderFns } from "./busRouteGoIndex.vue?vue&type=template&id=55415406&"
import script from "./busRouteGoIndex.vue?vue&type=script&lang=js&"
export * from "./busRouteGoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports